import {inject} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot} from '@angular/router';
import {AuthenticationService} from '~local/app/shared/services/authentication.service';
import {map} from 'rxjs/operators';


export const canActivateAuth: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const router = inject(Router);
    const authenticationService = inject(AuthenticationService);

    return authenticationService.isAuthenticated().pipe(
        map($isAuthenticated => {
            if (!$isAuthenticated) {
                router.navigate(['/login'], {queryParams: {redirect: state.url}, replaceUrl: true});
            }
            return $isAuthenticated;
        })
    );
};
